// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Authorized-viewer search
 */

.addViewer_wrap__e1qM6 {
  max-width: 620px;
  padding: var(--space-6);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--bg);
  box-shadow: var(--shadow-xs);
  box-sizing: border-box;
}

.addViewer_title__rxR6r {
  margin: 0 0 var(--space-4);
  font-size: 1.0625rem;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: -0.008em;
  color: var(--text-primary);
}

.addViewer_inputWrap__BSAk0 {
  position: relative;
}

.addViewer_input__9XGa9 {
  display: block;
  width: 100%;
  min-height: 40px;
  padding: 9px 12px;
  border: 1px solid var(--border-dark);
  border-radius: var(--radius-input);
  background: var(--bg);
  color: var(--text-primary);
  font-family: var(--font);
  font-size: 0.9375rem;
  line-height: 1.45;
  box-sizing: border-box;
  transition:
    border-color var(--dur-fast) var(--ease-standard),
    box-shadow var(--dur-fast) var(--ease-standard);
}

.addViewer_input__9XGa9::placeholder {
  color: var(--text-placeholder);
}

.addViewer_input__9XGa9:focus,
.addViewer_input__9XGa9:focus-visible {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(157, 31, 95, 0.12);
}

.addViewer_hint__TWuS- {
  margin: 6px 0 0;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: var(--text-secondary);
}

/* Results list */
.addViewer_results__eTPsG {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 10;
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--bg);
  box-shadow: var(--shadow-md);
}

.addViewer_resultsList__U0Voo {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 280px;
  overflow: auto;
  scrollbar-width: thin;
}

.addViewer_item__MRdnA {
  padding: var(--space-3) var(--space-4);
  cursor: pointer;
  transition: background-color var(--dur-fast) var(--ease-standard);
}

.addViewer_item__MRdnA + .addViewer_item__MRdnA {
  border-top: 1px solid var(--border-light);
}

.addViewer_item__MRdnA:hover,
.addViewer_item__MRdnA[aria-selected='true'],
.addViewer_item__MRdnA.addViewer_active__PyIov {
  background: var(--surface-brand-wash);
}

.addViewer_name__JAxk6 {
  display: block;
  font-size: 0.9375rem;
  font-weight: 700;
  line-height: 1.45;
  color: var(--text-primary);
}

.addViewer_email__1sjka {
  display: block;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: var(--text-secondary);
}

.addViewer_stateRow__2nTmS {
  padding: var(--space-3) var(--space-4);
  font-size: 0.875rem;
  color: var(--text-secondary);
}

/* Feedback */
.addViewer_status__XZgrP {
  margin-top: var(--space-3);
  padding: 9px 12px;
  border-radius: var(--radius-sm);
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.45;
}

.addViewer_status__XZgrP.addViewer_success__7Vits {
  background: var(--surface-success);
  color: #1b5e20;
}

.addViewer_status__XZgrP.addViewer_error__hE6et {
  background: var(--surface-error);
  color: #b71c1c;
}

@media (max-width: 600px) {
  .addViewer_wrap__e1qM6 {
    padding: var(--space-5);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DashBoard/addViewer.module.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,qBAAqB;EACrB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,kCAAkC;EAClC,qBAAqB;EACrB,0BAA0B;EAC1B,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB;;mDAEiD;AACnD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,iEAAiE;AACnE;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,aAAa;AACb;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/*\n * Authorized-viewer search\n */\n\n.wrap {\n  max-width: 620px;\n  padding: var(--space-6);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  background: var(--bg);\n  box-shadow: var(--shadow-xs);\n  box-sizing: border-box;\n}\n\n.title {\n  margin: 0 0 var(--space-4);\n  font-size: 1.0625rem;\n  font-weight: 700;\n  line-height: 1.4;\n  letter-spacing: -0.008em;\n  color: var(--text-primary);\n}\n\n.inputWrap {\n  position: relative;\n}\n\n.input {\n  display: block;\n  width: 100%;\n  min-height: 40px;\n  padding: 9px 12px;\n  border: 1px solid var(--border-dark);\n  border-radius: var(--radius-input);\n  background: var(--bg);\n  color: var(--text-primary);\n  font-family: var(--font);\n  font-size: 0.9375rem;\n  line-height: 1.45;\n  box-sizing: border-box;\n  transition:\n    border-color var(--dur-fast) var(--ease-standard),\n    box-shadow var(--dur-fast) var(--ease-standard);\n}\n\n.input::placeholder {\n  color: var(--text-placeholder);\n}\n\n.input:focus,\n.input:focus-visible {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(157, 31, 95, 0.12);\n}\n\n.hint {\n  margin: 6px 0 0;\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n/* Results list */\n.results {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  z-index: 10;\n  overflow: hidden;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: var(--bg);\n  box-shadow: var(--shadow-md);\n}\n\n.resultsList {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  max-height: 280px;\n  overflow: auto;\n  scrollbar-width: thin;\n}\n\n.item {\n  padding: var(--space-3) var(--space-4);\n  cursor: pointer;\n  transition: background-color var(--dur-fast) var(--ease-standard);\n}\n\n.item + .item {\n  border-top: 1px solid var(--border-light);\n}\n\n.item:hover,\n.item[aria-selected='true'],\n.item.active {\n  background: var(--surface-brand-wash);\n}\n\n.name {\n  display: block;\n  font-size: 0.9375rem;\n  font-weight: 700;\n  line-height: 1.45;\n  color: var(--text-primary);\n}\n\n.email {\n  display: block;\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n.stateRow {\n  padding: var(--space-3) var(--space-4);\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n}\n\n/* Feedback */\n.status {\n  margin-top: var(--space-3);\n  padding: 9px 12px;\n  border-radius: var(--radius-sm);\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.45;\n}\n\n.status.success {\n  background: var(--surface-success);\n  color: #1b5e20;\n}\n\n.status.error {\n  background: var(--surface-error);\n  color: #b71c1c;\n}\n\n@media (max-width: 600px) {\n  .wrap {\n    padding: var(--space-5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `addViewer_wrap__e1qM6`,
	"title": `addViewer_title__rxR6r`,
	"inputWrap": `addViewer_inputWrap__BSAk0`,
	"input": `addViewer_input__9XGa9`,
	"hint": `addViewer_hint__TWuS-`,
	"results": `addViewer_results__eTPsG`,
	"resultsList": `addViewer_resultsList__U0Voo`,
	"item": `addViewer_item__MRdnA`,
	"active": `addViewer_active__PyIov`,
	"name": `addViewer_name__JAxk6`,
	"email": `addViewer_email__1sjka`,
	"stateRow": `addViewer_stateRow__2nTmS`,
	"status": `addViewer_status__XZgrP`,
	"success": `addViewer_success__7Vits`,
	"error": `addViewer_error__hE6et`
};
export default ___CSS_LOADER_EXPORT___;
